import React, { FC } from 'react';

const Handbook: FC = () => (
  <iframe title="VL Handbook" className="clickup-embed clickup-dynamic-height" src="https://doc.clickup.com/2613163/d/h/2fqxb-5181/8af249599b8e2e2" width="100%" height="100%" />
);

export default Handbook;
